import Page from '../../../components/page.vue'
import book from '../../../components/book.vue'
import {api} from "../../../common/config";
import {ajaxUtil} from '../../../common/AjaxUtil.js';
import {CommonUtil} from '../../../common/CommonUtil.js';
import {store} from '../../../store/store.js'

export default {
  name: 'bookList',
  components: {
    Page,
    book
  },
  data() {
    return {
      keywords: "",
      webType: store.webType,
      typeId: 0,
      bookCategorys: [],
      pageNo: 1,
      totalPage: 1,
      pageCount: 8,
      books: [],
      activeTime: '',
      categoryId: 0,
      chooseItem: null,
      twoLevelCategoryId: 0,
      libId: 0,
      libCode: '',
      resource: '',
      ajaxStatus: false
    }
  },

  watch: {
    $route() {
      this.queryData();
    }
  },

  beforeMount() {
    this.queryData();
  },
  methods: {
    queryData() {
      this.typeId = this.$route.params.type;
      this.libCode = this.$route.query.libCode || this.$route.query.hallCode ||  store.library.libCode||'';
      this.libId = this.$route.query.libId;
      this.chooseItem = this.$route.query.chooseItem != undefined ? this.$route.query.chooseItem : -1;
      this.pageNo = this.$route.query.page || 1;
      this.activeTime = this.$route.query.activeTime || 0;
      this.categoryId = this.$route.query.categoryId || '';
      this.twoLevelCategoryId = this.$route.query.twoLevelCategoryId || 0;
      //高级搜索 resource
      if (this.typeId == 1) {
        this.resource = '/searchbook';
          Promise.all([this.category(api.book.category),this.bookBorrowing(api.book.borrowing)])
      } else {
        this.resource = '/searchebook';
          Promise.all([this.category(api.ebook.category), this.getLastestCatalogueEbook(api.ebook.lastestCatalogue)])
      }
    },

    category(param) {
      ajaxUtil.ajaxJson(param, null, "GET", (data) => {
        this.bookCategorys = data;
        this.bookCategorys.forEach((item, index) => {
          item.subListId = [];
          if (item.subList) {
            for (var i = 0; i < item.subList.length; i++) {
              item.subListId.push(String(item.subList[i].categoryId))
            }
          }
        })
      }, null, this);
    },

    bookBorrowing(param){   //图书馆图书借阅量排行
      this.ajaxStatus = true;
      var url = param.replace('{libCode}', this.libCode).replace('{pageNo}', Number(this.pageNo)).replace('{pageCount}', this.pageCount).replace('{categoryId}', this.categoryId);
      ajaxUtil.ajaxJson(url, null, "GET", (data)=> {
        this.ajaxStatus = false;
        this.books = data.resultList;
        this.totalPage = Math.ceil(data.totalCount / this.pageCount);
        this.pageNo = data.pageNo;
      }, null, this);
    },
    getLastestCatalogueEbook(param) {  //电子书最新上架
      this.ajaxStatus = true;
      this.categoryId = this.categoryId == '' || !this.categoryId ? 0 : this.categoryId;
      var url = param.replace('{pageNo}', this.pageNo).replace('{pageCount}', this.pageCount).replace('{oneLevelCategoryId}', Number(this.categoryId)) + '&twoLevelCategoryId=' + this.twoLevelCategoryId + "&libCode=" + this.libCode;
      ajaxUtil.ajaxJson(url, null, "GET", (data) => {
        this.ajaxStatus = false;
        this.books = data.resultList;
        this.totalPage = data.totalPage;
        this.pageNo = data.pageNo;
      }, null, this);
    },
    /**
     *
     * 页面跳转和搜索
     *
     */
    //搜索
    toResult() {
      this.keywords = CommonUtil.Trim(this.keywords);
      if (this.keywords == "" || this.keywords.length == 0) {
        return;
      }
      this.$router.push({path: 'indexsearch', query: {searchStr: this.keywords}});
    },
    toChooseItem(index) {
      this.chooseItem = index == this.chooseItem ? -1 : index;
    },
    //切换热门
    changeTime(type) {
      CommonUtil.mergeQuery(this,{page: 1,categoryId:this.categoryId, activeTime: type,chooseItem: this.chooseItem})
    },
    //点击分类
    categoryChange(id) {
      if(id == '') {
        this.chooseItem = -1;
      }
      this.categoryId=id;
      this.twoLevelCategoryId=0;
      CommonUtil.mergeQuery(this,{page: 1,categoryId: id,twoLevelCategoryId:0,activeTime: this.activeTime,chooseItem: this.chooseItem})
    },

    subCategoryChange(id,subId){
      if(id == '') {
        this.chooseItem = -1;
      }
      this.categoryId = id;
      this.twoLevelCategoryId=subId;
      CommonUtil.mergeQuery(this,{page: 1,categoryId: id,twoLevelCategoryId:subId, activeTime: this.activeTime,chooseItem: this.chooseItem})
    },

    //翻页操作
    pageChange(pageNo) {
      CommonUtil.mergeQuery(this,{page: pageNo})
    },
  }
}
